import * as React from "../../_snowpack/pkg/react.js";
import {surveyPrompts} from "../assets/surveyFormat.js";
const FormatDescription = () => {
  const [showQuestions, setShowQuestions] = React.useState(false);
  React.useEffect(() => {
    return () => {
      setShowQuestions(false);
    };
  }, []);
  return /* @__PURE__ */ React.createElement("section", {
    className: "flex flex-col items-start"
  }, /* @__PURE__ */ React.createElement("button", {
    className: "border p-1 border-blue-700 rounded-sm bg-blue-50",
    onClick: (e) => {
      e.preventDefault();
      setShowQuestions((s) => !s);
    }
  }, showQuestions ? "Hide" : "Show", " survey questions"), showQuestions ? /* @__PURE__ */ React.createElement("ol", {
    className: "list-decimal py-2 px-10 border border-blue-700",
    style: {transform: "translateY(-1px)"}
  }, surveyPrompts.map((prompt, idx) => /* @__PURE__ */ React.createElement("li", {
    className: "pl-2",
    key: `prompt/${idx}`
  }, idx === 12 ? /* @__PURE__ */ React.createElement("span", null, "Has your institution ever hosted an APS", " ", /* @__PURE__ */ React.createElement("a", {
    href: "https://www.aps.org/programs/women/sitevisits/",
    target: "_blank",
    rel: "noreferrer",
    className: "underline text-blue-800"
  }, "Climate Site Visit for Women and Minorities in Physics"), "?") : /* @__PURE__ */ React.createElement("span", null, prompt)))) : /* @__PURE__ */ React.createElement(React.Fragment, null), /* @__PURE__ */ React.createElement("p", {
    className: "mt-4"
  }, "The responses for each institution can be obtained by clicking on the name of the institution below."), /* @__PURE__ */ React.createElement("p", {
    className: "pb-4"
  }, "If you are a department chair or a graduate program director, and would like to add or change your institution's contribution, please email", " ", /* @__PURE__ */ React.createElement("a", {
    href: "mailto:women@aps.org",
    className: "text-blue-800 underline"
  }, "women@aps.org"), "."));
};
export default FormatDescription;
